import React from "react";
import styled from "styled-components";
import { reduxForm, Form, Field } from "redux-form";

import { GoogleSocialAuthButton } from "../../containers";

import { FormInput, AppStateDisplay } from "../../../common";
import strings from "../../../../res/strings";

const LoginFormContentContainer = styled(Form)`
  padding: 15%;
  padding-top: 25vh;
`;
const LoginFormContent = styled.div``;

const ForgotPasswordRedirectContent = styled.div`
  margin-top: 8px;
  text-align: end;
`;

const LoginFormButtons = styled.div`
  padding: 16px 24px 24px 24px;
`;

const SubmitButton = styled.button`
  width: 100%;
  background: #5cdade;
  border-radius: 250.251px;
  font-size: 1.5em;
  font-family: Secular One;
  color: #ffffff;
  align-items: center;
  text-align: center;
  letter-spacing: 0.05em;
  padding: 16px;
  :focus {
    outline: none;
    box-shadow: 0px 0px 2px #0066ff;
  }
`;

const RegisterRedirectContent = styled.div`
  margin-top: 16px;
  width: 100%;
  text-align: center;
`;

const RedirectContainer = styled.div`
  margin-bottom: 8px;
`;
const RouterLink = styled.a`
  color: #929292;
  font-family: Secular One;
  cursor: pointer;

  :hover {
    color: #7a7a7a;
  }
`;
const SignInTitle = styled.div`
  font-family: Secular One;
  font-style: normal;
  font-weight: normal;
  font-size: 2em;
  line-height: 73px;
  letter-spacing: 0.1em;

  color: #929292;
  text-align: center;
`;
const FieldsContainer = styled.div`
  margin-top: 16px;
`;

const LoginForm = (props) => {
  const { handleSubmit } = props;

  return (
    <LoginFormContentContainer onSubmit={handleSubmit}>
      <LoginFormContent>
        <SignInTitle>SIGN IN</SignInTitle>
        <AppStateDisplay parsedQuery={props.parsedQuery} />
        <FieldsContainer>
          <Field
            name="email"
            component={FormInput}
            label={strings.lib_authentication_label_email}
            type="email"
            required
            maxlength={255}
            placeholder={"EMAIL"}
          />
          <Field
            name="password"
            component={FormInput}
            label={strings.lib_authentication_label_password}
            type="password"
            required
            minlength={8}
            maxlength={128}
            placeholder={"PASSWORD"}
          />
        </FieldsContainer>
        <ForgotPasswordRedirectContent>
          <RouterLink
            onClick={() => {
              props.setRightPanel("FORGOT_PASSWORD");
            }}
          >
            Forgot Password?
          </RouterLink>
        </ForgotPasswordRedirectContent>
      </LoginFormContent>
      <LoginFormButtons>
        <SubmitButton type="submit" color="primary">
          ENTER YOUR VIRTUAL OFFICE
        </SubmitButton>
        <GoogleSocialAuthButton />
        <RegisterRedirectContent>
          <RedirectContainer>
            <RouterLink
              onClick={() => {
                props.clearAll();
                props.setRightPanel("REGISTER");
              }}
            >
              {strings.lib_authentication_redirect_register}
            </RouterLink>
          </RedirectContainer>
          <RedirectContainer>
            <RouterLink
              onClick={() => {
                props.clearAll();
                props.setRightPanel("RESEND_ACTIVATION");
              }}
            >
              {strings.lib_authentication_redirect_resend_activation_link}
            </RouterLink>
          </RedirectContainer>
        </RegisterRedirectContent>
      </LoginFormButtons>
    </LoginFormContentContainer>
  );
};

export default reduxForm({
  form: "lib_authentication_login",
})(LoginForm);
